<template>
  <div class="home-activity">
    <banner-swiper :banner="advertise.banner" :textinfo="textinfo" />

    <div class="home-activity-tab">
      <!--      <span :class="{ active: activityTab == 1 }" @click="activityTab = 1"-->
      <!--        >精选课程</span-->
      <!--      >-->
      <!--      <span :class="{ active: activityTab == 2 }" @click="activityTab = 2"-->
      <!--        >热门活动</span-->
      <!--      >-->
      <router-link tag="span" to="/activity/course" active-class="active"
        >精选课程</router-link
      >
      <router-link tag="span" to="/activity/activity" active-class="active"
        >热门活动</router-link
      >
    </div>
    <div class="home-activity-content">
      <!--      <course v-if="activityTab == 1" />-->
      <!--      <activity v-if="activityTab == 2" />-->
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import course from "./course.vue";
import activity from "./activity.vue";
import { getAdvertiseList } from "@/api/advertise";
import VImg from "@/components/VImg";
import BannerSwiper from "@/components/BannerSwiper";

export default {
  components: {
    course,
    activity,
    VImg,
    BannerSwiper,
  },
  data() {
    return {
      activityTab: 1,
      advertise: {
        banner: [],
        notif: "",
      },
      textinfo: {
        title: "培训课程",
        text: "完善的学习平台管理工具，高效推动学习效果",
        type: "activity",
        height: 280,
      },
    };
  },
  mounted() {
    if (this.$route.params.type) {
      this.activityTab = this.$route.params.type;
    }
    this.loadGetAdvertise();
  },

  methods: {
    loadGetAdvertise() {
      let params = {
        adType: "ACTIVITY_COURSE_BANNER",
        validStatus: "1",
      };

      getAdvertiseList(params).then((res) => {
        console.log(res, "====广告====");
        let data = res.records;
        data.forEach((item) => {
          if (
            item.adType === "ACTIVITY_COURSE_BANNER" &&
            item.validStatus == 1
          ) {
            this.advertise.banner.push(item);
          }
        });

        console.log(this.advertise, "advertise");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.home-activity {
  .home-activity-tab {
    background: #fff;
    display: flex;
    justify-content: center;
    > span {
      height: 66px;
      line-height: 66px;
      border-bottom: 2px solid transparent;
      cursor: pointer;
      transition: all 0.3s;
      font-size: 20px;
      color: #262626;
      &:first-child {
        margin-right: 200px;
      }
      &.active {
        border-color: #ea0b06;
      }
    }
  }
  .home-activity-content {
    width: 1280px;
    margin: 0 auto;
    padding: 24px 0 56px;
  }
}
</style>
